import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState } from '../types';
import { useBoardActivityStore } from '../useModule';

const { registerReducer } = useBoardActivityStore();

export class SetFollowChanges extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::SetFollowChanges';

    constructor(public isOn: boolean) {
        super(SetFollowChanges.ACTION_TYPE);
    }
}

const reducer = (state: BoardActivityPanelState, action: SetFollowChanges): void => {
    state.isFollowChangesOn = action.isOn;
};

//@ts-ignore
registerReducer(SetFollowChanges.ACTION_TYPE, reducer);
